import { Controller } from '@hotwired/stimulus';

/**
 * Tracking controller for dataLayer events.
 * Supports legacy (santianoEcommerce) and new (a.*) event formats.
 */

export default class extends Controller {
    static values = {
        event: { type: String, default: 'santianoEcommerce' },
        command: String,
        category: String,
        subCategory: { type: String, default: '' },
        label: String,
        contentName: String,
    };

    /**
     * Legacy push for santianoEcommerce events.
     */
    push() {
        const payload = {
            event: this.eventValue,
        };

        if (this.hasCommandValue) {
            payload.eventCommand = this.commandValue;
        }

        if (this.hasCategoryValue) {
            payload.category = this.categoryValue;
        }

        if (this.hasSubCategoryValue) {
            payload.subCategory = this.subCategoryValue;
        }

        if (this.hasLabelValue) {
            payload.label = this.labelValue;
        }

        if (this.hasContentNameValue) {
            payload.contentName = this.contentNameValue;
        }

        this.pushToDataLayer(payload);
    }

    /**
     * Push structured JSON payload from element's data-tracking-payload-value.
     * @param {Event} event - The click event
     */
    pushPayload(event) {
        const target = event.currentTarget;
        const payloadJson = target.dataset.trackingPayloadValue;

        if (!payloadJson) {
            console.warn(
                '[Tracking] No payload defined for pushPayload action',
            );
            return;
        }

        try {
            const payload = JSON.parse(payloadJson);
            this.pushToDataLayer(payload);
        } catch {
            console.error('[Tracking] Failed to parse payload JSON');
        }
    }

    /**
     * Push to dataLayer via consent manager (queues until Didomi ready).
     *
     * @param {object} payload - Event payload
     */
    pushToDataLayer(payload) {
        window.consentDataLayer?.queueOrPush(payload);
    }
}
